import React from "react";
import FormCharge from "./Form";

export default function CreateCharge() {
  return <FormCharge />
}



// WEBPACK FOOTER //
// ./src/components/Charges/CreateCharge.js